(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rlx-footer"]) return;
  try {
    
	class RlxFooter extends HTMLElement {
		constructor() {
			super();
			this.init()
		}

		init(){
			document.querySelector('.back-top').addEventListener('click', () => {
				window.scrollTo({
					top: 0,
					behavior: "smooth"
				});
			});
		}	
	}
	customElements.define('rlx-footer', RlxFooter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rlx-header"]) return;
  try {
    
	class RlxHeader extends HTMLElement {
		constructor() {
			super();
			this.init();
		}

		init() {
			this.nav = document.querySelector('.header-nav');
			this.navMobile = document.querySelector('.rlx-menu-button');
			this.wrapperNav = document.querySelector('.header-wrapper-nav');
			this.menuMobile = document.querySelector('.rlx-menu-mobile');

			if (!this.nav || !this.navMobile || !this.menuMobile) return;

			this.updateBurgerMenu();
			window.addEventListener("resize", () => this.updateBurgerMenu());
			this.navMobile.addEventListener('click', () => this.toggleMenuMobile());
		}

		updateBurgerMenu() {
			const navWidth = this.nav.getBoundingClientRect().width;
			const wrapperNavWidth = this.wrapperNav.getBoundingClientRect().width;

			if (navWidth >= wrapperNavWidth) {
				this.navMobile.classList.remove('md:hidden');
				this.nav.classList.remove('md:visible');
			} else {
				this.navMobile.classList.add('md:hidden');
				this.nav.classList.add('md:visible');
			}
		}

		toggleMenuMobile() {
			const menu = this.menuMobile;

			if (menu.classList.contains('invisible')) {
				menu.classList.remove('invisible');
				return;
			}

			menu.classList.add('closing');

			setTimeout(() => {
				menu.classList.remove('closing');
				menu.classList.add('invisible');
			}, 400);
		}
	}

	customElements.define('rlx-header', RlxHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rlx-main-collection-product-grid"]) return;
  try {
    
	class MenuDrawer extends HTMLElement {
		constructor() {
			super();

			this.mainDetailsToggle = this.querySelector('details');

			this.addEventListener('keyup', this.onKeyUp.bind(this));
			this.addEventListener('focusout', this.onFocusOut.bind(this));
			this.bindEvents();
		}

		bindEvents() {
			this.querySelectorAll('summary').forEach((summary) =>
				summary.addEventListener('click', this.onSummaryClick.bind(this))
			);
			this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
				button.addEventListener('click', this.onCloseButtonClick.bind(this))
			);
		}

		onKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			const openDetailsElement = event.target.closest('details[open]');
			if (!openDetailsElement) return;

			openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
			: this.closeSubmenu(openDetailsElement);
		}

		onSummaryClick(event) {
			const summaryElement = event.currentTarget;
			const detailsElement = summaryElement.parentNode;
			const parentMenuElement = detailsElement.closest('.has-submenu');
			const isOpen = detailsElement.hasAttribute('open');
			const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

			function addTrapFocus() {
				trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
				summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
			}

			if (detailsElement === this.mainDetailsToggle) {
				if (isOpen) event.preventDefault();
				isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

				if (window.matchMedia('(max-width: 990px)')) {
					document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
				}
			} else {
				setTimeout(() => {
					detailsElement.classList.add('menu-opening');
					summaryElement.setAttribute('aria-expanded', true);
					parentMenuElement && parentMenuElement.classList.add('submenu-open');
					!reducedMotion || reducedMotion.matches
					? addTrapFocus()
					: summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
				}, 100);
			}
		}

		openMenuDrawer(summaryElement) {
			setTimeout(() => {
				this.mainDetailsToggle.classList.add('menu-opening');
			});
			summaryElement.setAttribute('aria-expanded', true);
			trapFocus(this.mainDetailsToggle, summaryElement);
			document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
		}

		closeMenuDrawer(event, elementToFocus = false) {
			if (event === undefined) return;

			this.mainDetailsToggle.classList.remove('menu-opening');
			this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
				details.removeAttribute('open');
				details.classList.remove('menu-opening');
			});
			this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
				submenu.classList.remove('submenu-open');
			});
			document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
			removeTrapFocus(elementToFocus);
			this.closeAnimation(this.mainDetailsToggle);

			if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
		}

		onFocusOut() {
			setTimeout(() => {
			if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
				this.closeMenuDrawer();
			});
		}

		onCloseButtonClick(event) {
			const detailsElement = event.currentTarget.closest('details');
			this.closeSubmenu(detailsElement);
		}

		closeSubmenu(detailsElement) {
			const parentMenuElement = detailsElement.closest('.submenu-open');
			parentMenuElement && parentMenuElement.classList.remove('submenu-open');
			detailsElement.classList.remove('menu-opening');
			detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
			removeTrapFocus(detailsElement.querySelector('summary'));
			this.closeAnimation(detailsElement);
		}

		closeAnimation(detailsElement) {
			let animationStart;

			const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time;
			}

			const elapsedTime = time - animationStart;

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation);
			} else {
				detailsElement.removeAttribute('open');
				if (detailsElement.closest('details[open]')) {
					trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
				}
			}
			};

			window.requestAnimationFrame(handleAnimation);
		}
	}

	customElements.define('menu-drawer', MenuDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rlx-products-grid"]) return;
  try {
    
	class RlxProductGrid extends HTMLElement {
		constructor() {
			super();
			this.grid = this.querySelector('.js-product-grid');
			this.showMore = this.querySelector('.js-show-more');
			this.loading = false;

			this.showMore?.addEventListener('click', this.loadMore.bind(this));
		}

		async loadMore() {
			const nextUrl = this.dataset.url;
			if (!nextUrl || this.loading) return;

			this.loading = true;
			this.showMore.disabled = true;
			this.showMore.setAttribute('aria-busy', 'true');

			try {
				const url = new URL(nextUrl, window.location.origin);
				url.searchParams.set('section_id', this.dataset.sectionId);

				const response = await fetch(url.toString());
				const html = await response.text();
				const newRoot = new DOMParser().parseFromString(html, 'text/html').getElementById(this.id);
				const newCards = newRoot?.querySelector('.js-product-grid')?.innerHTML;

				if (newCards) {
					this.grid.insertAdjacentHTML('beforeend', newCards);
				}

				this.dataset.url = newRoot?.dataset.url || '';
			} catch (error) {
				this.dataset.url = '';
			} finally {
				this.loading = false;

				if (this.dataset.url) {
					this.showMore.disabled = false;
					this.showMore.removeAttribute('aria-busy');
				} else {
					this.showMore.remove();
				}
			}
		}
	}
	customElements.define('rlx-product-grid', RlxProductGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tudor-main-collection-product-grid"]) return;
  try {
    
	class MenuDrawer extends HTMLElement {
		constructor() {
			super();

			this.mainDetailsToggle = this.querySelector('details');

			this.addEventListener('keyup', this.onKeyUp.bind(this));
			this.addEventListener('focusout', this.onFocusOut.bind(this));
			this.bindEvents();
		}

		bindEvents() {
			this.querySelectorAll('summary').forEach((summary) =>
				summary.addEventListener('click', this.onSummaryClick.bind(this))
			);
			this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
				button.addEventListener('click', this.onCloseButtonClick.bind(this))
			);
		}

		onKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			const openDetailsElement = event.target.closest('details[open]');
			if (!openDetailsElement) return;

			openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
			: this.closeSubmenu(openDetailsElement);
		}

		onSummaryClick(event) {
			const summaryElement = event.currentTarget;
			const detailsElement = summaryElement.parentNode;
			const parentMenuElement = detailsElement.closest('.has-submenu');
			const isOpen = detailsElement.hasAttribute('open');
			const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

			function addTrapFocus() {
				trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
				summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
			}

			if (detailsElement === this.mainDetailsToggle) {
				if (isOpen) event.preventDefault();
				isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

				if (window.matchMedia('(max-width: 990px)')) {
					document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
				}
			} else {
				setTimeout(() => {
					detailsElement.classList.add('menu-opening');
					summaryElement.setAttribute('aria-expanded', true);
					parentMenuElement && parentMenuElement.classList.add('submenu-open');
					!reducedMotion || reducedMotion.matches
					? addTrapFocus()
					: summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
				}, 100);
			}
		}

		openMenuDrawer(summaryElement) {
			setTimeout(() => {
				this.mainDetailsToggle.classList.add('menu-opening');
			});
			summaryElement.setAttribute('aria-expanded', true);
			trapFocus(this.mainDetailsToggle, summaryElement);
			document.body.classList.add(`tudor-overflow-hidden`);
		}

		closeMenuDrawer(event, elementToFocus = false) {
			if (event === undefined) return;

			this.mainDetailsToggle.classList.remove('menu-opening');
			this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
				// details.removeAttribute('open');
				details.classList.remove('menu-opening');
			});
			this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
				submenu.classList.remove('submenu-open');
			});
			document.body.classList.remove(`tudor-overflow-hidden`);
			removeTrapFocus(elementToFocus);
			this.closeAnimation(this.mainDetailsToggle);

			if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
		}

		onFocusOut() {
			setTimeout(() => {
			if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
				this.closeMenuDrawer();
			});
		}

		onCloseButtonClick(event) {
			const detailsElement = event.currentTarget.closest('details');
			this.closeSubmenu(detailsElement);
		}

		closeSubmenu(detailsElement) {
			const parentMenuElement = detailsElement.closest('.submenu-open');
			parentMenuElement && parentMenuElement.classList.remove('submenu-open');
			detailsElement.classList.remove('menu-opening');
			detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
			removeTrapFocus(detailsElement.querySelector('summary'));
			this.closeAnimation(detailsElement);
		}

		closeAnimation(detailsElement) {
			let animationStart;

			const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time;
			}

			const elapsedTime = time - animationStart;

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation);
			} else {
				detailsElement.removeAttribute('open');
				if (detailsElement.closest('details[open]')) {
					trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
				}
			}
			};

			window.requestAnimationFrame(handleAnimation);
		}
	}

	customElements.define('tudor-menu-drawer', MenuDrawer);

  } catch(e) { console.error(e); }
})();
})();
